import { AfterContentChecked, Component } from '@angular/core';
import { PNG } from 'src/app/shared/constants/constants';
import { ROUTE_ASSETS_IMAGES } from 'src/app/shared/constants/route-paths';
import { LandingPageService } from '../../service/landing-page.service';


@Component({
  selector: 'app-cloud-engineering',
  templateUrl: './cloud-engineering.component.html',
  styleUrls: ['./cloud-engineering.component.scss']
})
export class CloudEngineeringComponent implements AfterContentChecked {

    public productsList: any = [];

    constructor(private landingPageService: LandingPageService) { }

    public ngAfterContentChecked() {
        this.productsList = this.landingPageService.getSelectedTabProdcutsList('architectureService');
    }

    /**
     *
     * this methos will return the url for icons
     * @param {string} icon
     * @return {*}  {string}
     * @memberof NavbarComponent
     */
     public getUrl(icon: string): string {
      return ROUTE_ASSETS_IMAGES + icon + PNG;
  }
}
